import { useIsComplexCell } from "../hooks/useIsComplexCell";
import { getCellValue } from "../utils";

import { FullscreenBasicCell } from "./FullscreenBasicCell";
import { FullscreenComplexCell } from "./FullscreenComplexCell";

import { CopyButton } from "@/components/ui/copy-button";
import { ReportCell, ReportColumn } from "@/types/evaluate";

interface FullscreenDialogContentProps {
  cell: ReportCell;
  column: ReportColumn;
  viewMode?: "normal" | "raw";
}

export const FullscreenDialogContent = ({
  cell,
  column,
  viewMode = "normal",
}: FullscreenDialogContentProps) => {
  const isComplexCell = useIsComplexCell(cell, column);

  if (viewMode === "raw") {
    const rawJson = String(getCellValue(cell, column.column_type) ?? "");
    return (
      <div className="flex flex-1 flex-col overflow-hidden bg-background">
        <div className="flex justify-end border-b px-4 py-2">
          <CopyButton text={rawJson} />
        </div>
        <div className="flex-1 overflow-auto px-4 py-4">
          <pre className="whitespace-pre-wrap break-all font-mono text-sm text-foreground">
            {rawJson}
          </pre>
        </div>
      </div>
    );
  }

  return (
    <div className="flex-1 overflow-auto bg-background">
      <div className="px-4 pb-4">
        {isComplexCell ? (
          <FullscreenComplexCell cell={cell} column={column} />
        ) : (
          <FullscreenBasicCell cell={cell} column={column} />
        )}
      </div>
    </div>
  );
};
